import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'piqet-angular-bookmark',
  templateUrl: './bookmark.component.html',
  styleUrls: ['./bookmark.component.css'],
})
export class BookmarkComponent {
  params: any;
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }

  updateBookmark() {
    this.params?.updateBookmark(this.params.data);
  }
}
